export default __webpack_public_path__ + "static/media/IkonEnkelInvestering.36d23790.svg";